import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Urls } from '../../../../Urls';
import Axios from '../../../../Axios/Axios';
import './TransitTimeSummary.css';
import ProfileModal from '../../../TransporterClientScreen/ProfileModal/ProfileModal';

const TransitTimeSummary = ({ from_date, to_date, transporter_list, email, email_list, route, contracted_time, indent_info }) => {
  const [transitTimeSummary, setTransitTimeSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const payload = {
      from_date,
      to_date,
      transporter_list,
      email,
      email_list,
      route,
    };

    Axios.post(`${Urls.indent}?field=transit_time_summary`, payload)
      .then((response) => {
        if (response.data) {
          setTransitTimeSummary(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
        toast.error('Error fetching transit time summary data');
      });
  }, [from_date, to_date, transporter_list, email, email_list, route]);

  // Format datetime with date and time on separate lines
  const formatDateTime = (dateInput) => {
    if (!dateInput) return { date: '-', time: '' };

    try {
      let date;

      if (dateInput.$date) {
        date = new Date(dateInput.$date);
      } else if (typeof dateInput === 'string') {
        date = new Date(dateInput);
      } else {
        date = new Date(dateInput);
      }

      if (isNaN(date.getTime())) {
        return { date: '-', time: '' };
      }

      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();

      let dateStr = `${day}-${month}-${year}`;

      const timeStr = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });

      return { date: dateStr, time: timeStr };
    } catch (e) {
      return { date: '-', time: '' };
    }
  };

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (error) {
    return <div className="error-container">Error: {error.message}</div>;
  }

  const matchedIndents = transitTimeSummary?.indent_info?.matched_indents?.filter(data => Object.keys(data).length > 0) || [];

  return (
    <div className="table-wrapper-transit">
      <div className="summary-header">
        <div className="route-info">
          <span className="location">
            {indent_info.origin.location_name}
          </span>

          <i className="fa fa-arrow-right route-arrow" />

          <span className="location">
            {indent_info.destination.location_name}
          </span>
        </div>

        <div className="truck-info">
          <i className="fa fa-truck truck-icon" />
          <span>{indent_info.truck_types[0].label}</span>
        </div>
      </div>

      {matchedIndents.length > 0 && <div className="table-container">
        <table className="transit-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Indent ID</th>
              <th>Transporter Name</th>
              <th>Placement Date</th>
              <th>Dispatched DateTime</th>
              <th>Reached DateTime</th>
              <th>Actual Transit Time(Days)</th>
              <th>Contracted Transit Time</th>
              <th>Status of Delivery</th>
            </tr>
          </thead>
          <tbody>
            {matchedIndents.map((data, index) => {
              const dispatchedDT = formatDateTime(data?.dispatched_datetime);
              const reachedDT = formatDateTime(data?.reached_datetime);

              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className="indent-id">
                    {data.display_indent_id || "-"}

                    {data.from_spot && (
                      <div style={{ color: "#28a745", fontWeight: 600 }}>
                        From Spot
                      </div>
                    )}
                  </td>

                  {/* <td>{data.transporter_name || 'N/A'}</td> */}
                  <td><ProfileModal transporter_name={data.transporter_name} transporter_id={data.transporter_id} /></td>
                  {/* <td>{data.transporter_id || 'N/A'}</td> */}
                  <td>
                    <div className="date-only">
                      {data?.placement_date}
                      {/* {console.log("Formatted Placement Date:", formatDate(data.placement_date))} */}

                    </div>
                  </td>
                  <td>
                    <div className="datetime-cell">
                      <div className="date-part">{dispatchedDT.date}</div>
                      {dispatchedDT.time && <div className="time-part">{dispatchedDT.time}</div>}
                    </div>
                  </td>
                  <td>
                    <div className="datetime-cell">
                      <div className="date-part">{reachedDT.date}</div>
                      {reachedDT.time && <div className="time-part">{reachedDT.time}</div>}
                    </div>
                  </td>
                  <td>{data.actual_transit_time || "-"} </td>
                  <td>{(contracted_time) ? `${contracted_time} Days` : ""}</td>
                  <td>
                    <span className={`status-badge status-${(data.status_of_delivery || '').toLowerCase()}`}>
                      {data.status_of_delivery || '-'}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>}
    </div>
  );
};

export default TransitTimeSummary;